import { createContext } from 'react';

import { captureException } from '@sentry/browser';

export interface UseUpsertInfieldLocationConfigMutationContextInterface {
  captureException: typeof captureException;
}

export const defaultValue: UseUpsertInfieldLocationConfigMutationContextInterface =
  {
    captureException,
  };

export const UseUpsertInfieldLocationConfigMutationContext =
  createContext<UseUpsertInfieldLocationConfigMutationContextInterface>(
    defaultValue
  );
